/** True only when the API explicitly enables multiplay (not null/undefined/false). */
export function isMultiplaySession(user) {
  if (!user) return false;
  const v = user.isMultiplaySession;
  if (
    v == null ||
    v === false ||
    v === "false" ||
    v === 0 ||
    v === "0" ||
    v === undefined ||
    v === "undefined"
  ) {
    return false;
  }
  return v === true || v === "true" || v === 1 || v === "1";
}
